import { isJalali } from './jaryanCalendar';
import { getTranslationFn } from './localization';

// Persian and Arabic-Indic digits, as a Persian or Arabic keyboard types them. Upstream's fields strip with `[^\d]`,
// and in JavaScript `\d` matches ASCII `0-9` only, so these digits would be thrown away as non-digits
const PERSIAN_ZERO = 0x06F0;
const ARABIC_INDIC_ZERO = 0x0660;
const NON_LATIN_DIGIT = /[۰-۹٠-٩]/g;
const NUMBER_CHARACTER = /[\d., %]/g;
const LEFT_TO_RIGHT_ISOLATE = '\u2066';
const POP_DIRECTIONAL_ISOLATE = '\u2069';
const PERSIAN_NUMBER_SIGNS: Record<string, string> = {
  '.': '٫',
  ',': '٫',
  ' ': '٬',
  '%': '٪',
};

export function toLatinDigits(text: string) {
  return text.replace(NON_LATIN_DIGIT, (digit) => {
    const charCode = digit.charCodeAt(0);
    return String(charCode - (charCode >= PERSIAN_ZERO ? PERSIAN_ZERO : ARABIC_INDIC_ZERO));
  });
}

// A number the app writes itself, as a Persian interface shows it. Display only: never for text that is parsed,
// copied as data or sent, because `\d` and `Number` read ASCII digits only
export function toDisplayNumber(text: string) {
  if (!isJalali(getTranslationFn().code)) return text;

  return text.replace(NUMBER_CHARACTER, (character) => (
    PERSIAN_NUMBER_SIGNS[character] ?? String.fromCharCode(PERSIAN_ZERO + Number(character))
  ));
}

// A phone number put into a sentence. In a right-to-left sentence its groups would otherwise run backwards and its plus
// would move to the far end. The isolate is invisible, so it is for display only: never for text that is copied or parsed
export function isolateLeftToRight(text: string) {
  return `${LEFT_TO_RIGHT_ISOLATE}${text}${POP_DIRECTIONAL_ISOLATE}`;
}
